export default "__VITE_ASSET__e7ab4e4d__"